import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsGlassSkin = {
  ...textEffectsSharedSkin,
  'text-color': {
    type: 'COLOR',
    defaultValue: '#FFFFFF',
  },
  'border-color': {
    type: 'COLOR',
    defaultValue: '#FF0033',
  },
  'border-width': {
    type: 'ALPHA',
    defaultValue: '1',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: 'url(#glass-shadow_blur:0)',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsGlassSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsGlass': TextEffectsGlassSkin,
  };

export default generateSkinDefaults(TextEffectsGlassSkinDefinitionMap);
